import classNames from 'classnames';

import CloseIcon from '@svg/close.svg';
import { ActiveFilters } from '@hook/productFilters';
import { SliderArrowProps, SliderArrow } from '@ui/SliderArrow';
import SlickSlider from '@ui/SlickSlider';
import { Image } from '@ui/Image';
import { Button } from '@ui/Button';

import s from './CatalogThematicFilters.sss';

type Theme = 'default' | 'brand' | 'tag';

type ArrowProps = SliderArrowProps & {
  theme?: Theme,
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ArrowLeft: React.FC<ArrowProps> = ({ className, ...props }) => (
  <SliderArrow
    {...props}
    direction="left"
    overrideClassName={classNames(s.arrow, {
      [s.arrowThemeDefault]: props.theme === 'default',
    })}
  />
);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ArrowRight: React.FC<ArrowProps> = ({ className, ...props }) => (
  <SliderArrow
    {...props}
    overrideClassName={classNames(s.arrow, {
      [s.arrowThemeDefault]: props.theme === 'default',
    })}
  />
);

export interface Filter {
  title?: string,
  image?: string | null,
  key?: keyof ActiveFilters,
  value?: number,
  url?: string | null,
  isActive?: boolean,
  brandName?: string,
}

interface Props {
  theme?: Theme,
  filters: Filter[],
  onToggle: (filter: Filter) => void,
}

export const CatalogThematicFilters: React.FC<Props> = ({
  theme = 'default',
  filters,
  onToggle,
}) => (
  <SlickSlider
    className={s.carousel}
    speed={400}
    prevArrow={<ArrowLeft theme={theme} />}
    nextArrow={<ArrowRight theme={theme} />}
    slidesToShow={1}
    infinite={false}
    centerMode={false}
    variableWidth={true}
    swipeToSlide={true}
    waitForAnimate={false}
  >
    {filters.map((filter, i) => (
      <div
        key={i}
          className={classNames(s.item, {
            [s.itemThemeBrand]: theme === 'brand',
            [s.itemThemeTag]: theme === 'tag',
          })}
      >
        <Button
          theme="text"
          className={classNames(s.button, {
            [s.buttonStateActive]: !!filter.isActive,
          })}
          {...(filter.url && { to: filter.url })}
          onClick={(e) => {
            e.preventDefault();

            onToggle(filter);
          }}
        >
          {!!filter.image && (
            <div className={s.imageHolder}>
              <Image
                className={s.image}
                src={filter.image}
                alt={filter.title}
              />
            </div>
          )}

          {!!filter.title && (
            <p className={s.title}>
              {filter.title}
            </p>
          )}
        </Button>

        {!!filter.isActive && (
          <Button
            className={s.closeButton}
            type="button"
            theme="text"
            onClick={(e) => {
              e.preventDefault();

              onToggle(filter);
            }}
          >
            <CloseIcon
              className={s.closeIcon}
              width="16"
              height="16"
            />
          </Button>
        )}
      </div>
    ))}
  </SlickSlider>
);
